import { createSelector } from '@reduxjs/toolkit';

import { CONNECTION_STATUS } from './types';

import type { AppState } from '../types';

export const getAblyConnectionStatus = (state: AppState) => state.connection.ablyStatus;
export const getAblyCustomerConnectionStatus = (state: AppState) =>
  state.connection.ablyCustomerStatus;
export const getLocalServerConnectionStatus = (state: AppState) =>
  state.connection.localServerStatus;

export const getConnectionStatus = (state: AppState) =>
  state.connection.localServerStatus === 'connected' ? 'connected' : state.connection.ablyStatus;

export const getIsConnected = createSelector(
  [getAblyConnectionStatus, getLocalServerConnectionStatus],
  (ablyStatus, localServerStatus) => {
    return ablyStatus === CONNECTION_STATUS.CONNECTED || localServerStatus === 'connected';
  },
);
